<app-admin-custom-control [label]="label" [centerLabel]="centerLabel" [labelCols]="labelCols" [disabled]="disabled"
  [dividerKind]="dividerKind">
  <angular-editor [id]="'edit'+uniqueId" [ngModel]="model" (ngModelChange)="modelChange.emit($event)"
    [config]="editorConfig"></angular-editor>
</app-admin-custom-control>